import { render, staticRenderFns } from "./SettingsOrganizerName.vue?vue&type=template&id=04ed1058&"
import script from "./SettingsOrganizerName.vue?vue&type=script&lang=js&"
export * from "./SettingsOrganizerName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports